import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'
export const StaticRouterMap = [
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    children: [
      {
        path: 'home',
        name: 'home',
        component: () => import('@/views/system/home'),
        hidden: true
      },
      //协会概况
      {
        path: '/xhgk',
        name: 'xhgk',
        component: () => import('@/views/system/xhgk/index'),
        hidden: true,
        redirect: '/xhgk',
        children: [
          {
            path: '/xhgk', //协会概况
            component: () => import('@/views/system/xhgk/xhgk.vue')
          },
          {
            path: '/xhjj', //协会简介
            component: () => import('@/views/system/xhgk/xhjj.vue')
          },
          {
            path: '/xhzc', //协会章程
            component: () => import('@/views/system/xhgk/xhzc.vue')
          },
          {
            path: '/xhld', //协会领导
            component: () => import('@/views/system/xhgk/xhld.vue')
          },
          {
            path: '/xhlddetai', //协会领导
            component: () => import('@/views/system/xhgk/xhlddetai.vue')
          },
          {
            path: '/zzjg', //组织架构
            component: () => import('@/views/system/xhgk/zzjg.vue')
          },
          {
            path: '/fzjg',
            name: 'fzjg',
            component: () => import('@/views/system/xhgk/fzjg/index'),
            hidden: true,
            redirect: '/fzjgglzdjtz',
            children: [
              {
                path: '/fzjgglzdjtz', //分支机构管理制度及通知
                component: () =>
                  import('@/views/system/xhgk/fzjg/fzjgglzdjtz/fzjgglzdjtz.vue')
              },
              {
                path: '/fzjgglzdjtz/:id', //分支机构管理制度及通知--详情
                component: () =>
                  import('@/views/system/xhgk/fzjg/fzjgglzdjtz/details.vue')
              },
              {
                path: '/jcfh', //检测分会
                component: () =>
                  import('@/views/system/xhgk/fzjg/jcfh/jcfh.vue')
              },
              {
                path: '/jcfh/:id', //检测分会--详情
                component: () =>
                  import('@/views/system/xhgk/fzjg/jcfh/details.vue')
              },
              {
                path: '/xyzlycxjsgzwyh', //行业自律与诚信建设工作委员会
                component: () =>
                  import('@/views/system/xhgk/fzjg/xyzlycxjsgzwyh/xyzlycxjsgzwyh.vue')
              },
              {
                path: '/xyzlycxjsgzwyh/:id', //行业自律与诚信建设工作委员会--详情
                component: () =>
                  import('@/views/system/xhgk/fzjg/xyzlycxjsgzwyh/details.vue')
              },
              {
                path: '/jyzxgzwyh', //认证认可政策法规研究与咨询工作委员会
                component: () =>
                  import('@/views/system/xhgk/fzjg/jyzxgzwyh/jyzxgzwyh.vue')
              },
              {
                path: '/jyzxgzwyh/:id', //认证认可政策法规研究与咨询工作委员会--详情
                component: () =>
                  import('@/views/system/xhgk/fzjg/jyzxgzwyh/details.vue')
              },
              {
                path: '/rzzxzywyh', //认证咨询专业委员会
                component: () =>
                  import('@/views/system/xhgk/fzjg/rzzxzywyh/rzzxzywyh.vue')
              },
              {
                path: '/rzzxzywyh/:id', //认证咨询专业委员会--详情
                component: () =>
                  import('@/views/system/xhgk/fzjg/rzzxzywyh/details.vue')
              },
              {
                path: '/qywhgzwyh', //权益维护工作委员会
                component: () =>
                  import('@/views/system/xhgk/fzjg/qywhgzwyh/qywhgzwyh.vue')
              },
              {
                path: '/qywhgzwyh/:id', //权益维护工作委员会--详情
                component: () =>
                  import('@/views/system/xhgk/fzjg/qywhgzwyh/details.vue')
              },
              {
                path: '/rzjszywyh', //认证技术专业委员会
                component: () =>
                  import('@/views/system/xhgk/fzjg/rzjszywyh/rzjszywyh.vue')
              },
              {
                path: '/rzjszywyh/:id', //权益维护工作委员会--详情
                component: () =>
                  import('@/views/system/xhgk/fzjg/rzjszywyh/details.vue')
              },
              {
                path: '/kjcg', //科技成果评价专业委员会
                component: () =>
                  import('@/views/system/xhgk/fzjg/kjcg/kjcg.vue')
              },
              {
                path: '/kjcg/:id', //科技成果评价专业委员会--详情
                component: () =>
                  import('@/views/system/xhgk/fzjg/kjcg/details.vue')
              },
              {
                path: '/spaq', //食品安全管理师评价专业委员会
                component: () =>
                  import('@/views/system/xhgk/fzjg/spaq/spaq.vue')
              },
              {
                path: '/spaq/:id', //食品安全管理师评价专业委员会--详情
                component: () =>
                  import('@/views/system/xhgk/fzjg/spaq/details.vue')
              },
              {
                path: '/STWYH', //“双碳”服务与认证工作委员会
                component: () =>
                  import('@/views/system/xhgk/fzjg/STWYH/STWYH.vue')
              },

              {
                path: '/STWYH/:id', //“双碳”服务与认证工作委员会--详情
                component: () =>
                  import('@/views/system/xhgk/fzjg/STWYH/details.vue')
              },
              {
                path: '/kcxfz', //“双碳”服务与认证工作委员会
                component: () =>
                  import('@/views/system/xhgk/fzjg/kcxfz/kcxfz.vue')
              },
              {
                path: '/kcxfz/:id', //“双碳”服务与认证工作委员会--详情
                component: () =>
                  import('@/views/system/xhgk/fzjg/kcxfz/details.vue')
              },
              {
                path: '/furzgz', //服务认证工作委员会
                component: () =>
                  import('@/views/system/xhgk/fzjg/furzgz/furzgz.vue')
              },
              {
                path: '/furzgz/:id', //服务认证工作委员会--详情
                component: () =>
                  import('@/views/system/xhgk/fzjg/furzgz/details.vue')
              },
              {
                path: '/yjcyyrzzywyh', //有机产业与认证专业委员会
                component: () =>
                  import('@/views/system/xhgk/fzjg/yjcyyrzzywyh/yjcyyrzzywyh.vue')
              },
              {
                path: '/yjcyyrzzywyh/:id', //有机产业与认证专业委员会--详情
                component: () =>
                  import('@/views/system/xhgk/fzjg/yjcyyrzzywyh/details.vue')
              },
              {
                path: '/ryzcysswyh', //人员注册与申投诉委员会
                component: () =>
                  import('@/views/system/xhgk/fzjg/ryzcysswyh/ryzcysswyh.vue')
              },
              {
                path: '/ryzcysswyh/:id', //人员注册与申投诉委员会--详情
                component: () =>
                  import('@/views/system/xhgk/fzjg/ryzcysswyh/details.vue')
              }
            ]
          }
        ]
      },
      //新闻报道
      {
        path: '/xwbd',
        name: 'xwbd',
        component: () => import('@/views/system/xwbd/index'),
        hidden: true,
        redirect: '/xwbd',
        children: [
          {
            path: '/xwbd', //新闻报道
            component: () => import('@/views/system/xwbd/xwbd.vue')
          },
          {
            path: '/xhxw', //协会新闻
            component: () => import('@/views/system/xwbd/xhxw/xhxw.vue')
          },
          {
            path: '/xhxw/:id', //协会新闻--详情
            component: () => import('@/views/system/xwbd/xhxw/details.vue')
          },
          {
            path: '/xyxw', //行业新闻
            component: () => import('@/views/system/xwbd/xyxw/xyxw.vue')
          },
          {
            path: '/xyxw/:id', //行业新闻--详情
            component: () => import('@/views/system/xwbd/xyxw/details.vue')
          },
          {
            path: '/hyfc', //会员风采
            component: () => import('@/views/system/xwbd/hyfc/hyfc.vue')
          },
          {
            path: '/hyfc/:id', //会员风采--详情
            component: () => import('@/views/system/xwbd/hyfc/details.vue')
          }
        ]
      },
      //信息发布
      {
        path: '/xxfb',
        name: 'xxfb',
        component: () => import('@/views/system/xxfb/index'),
        hidden: true,
        redirect: '/xxfb',
        children: [
          {
            path: '/xxfb', //信息发布
            component: () => import('@/views/system/xxfb/xxfb.vue')
          },
          {
            path: '/zxtz', //最新通知
            component: () => import('@/views/system/xxfb/zxtz/zxtz.vue')
          },
          {
            path: '/zxtz/:id', //最新通知--详情
            component: () => import('@/views/system/xxfb/zxtz/details.vue')
          },
          {
            path: '/ggsm', //公告声明
            component: () => import('@/views/system/xxfb/ggsm/ggsm.vue')
          },
          {
            path: '/ggsm/:id', //公告声明--详情
            component: () => import('@/views/system/xxfb/ggsm/details.vue')
          },
          {
            path: '/shzrbg', //社会责任报告
            component: () => import('@/views/system/xxfb/shzrbg/shzrbg.vue')
          },
          {
            path: '/shzrbg/:id', //社会责任报告--详情
            component: () => import('@/views/system/xxfb/shzrbg/details.vue')
          }
        ]
      },
      //服务之窗
      {
        path: '/fwzc',
        name: 'fwzc',
        component: () => import('@/views/system/fwzc/index'),
        hidden: true,
        redirect: '/fwzc',
        children: [
          {
            path: '/fwzc', //
            component: () => import('@/views/system/fwzc/fwzc.vue')
          },
          {
            path: '/wyzc1', //我要注册
            name: 'wyzc1',
            component: () => import('@/views/system/fwzc/wyzc/index.vue'),
            hidden: true,
            redirect: '/wyzc',
            children: [
              {
                path: '/wyzc', //我要注册
                component: () =>
                  import('@/views/system/fwzc/wyzc/wyzc/wyzc.vue')
              },
              {
                path: '/wyzc/:id', //我要注册--详情
                component: () =>
                  import('@/views/system/fwzc/wyzc/wyzc/details.vue')
              },
              {
                path: '/qrgf', //确认规范
                component: () =>
                  import('@/views/system/fwzc/wyzc/qrgf/qrgf.vue')
              },
              {
                path: '/qrgf/:id', //确认规范--详情
                component: () =>
                  import('@/views/system/fwzc/wyzc/qrgf/details.vue')
              },
              {
                path: '/zxgs', //中心概述

                component: () =>
                  import('@/views/system/fwzc/wyzc/zxgs/zxgs.vue')
              },
              {
                path: '/zxgs/:id', //中心概述--详情
                component: () =>
                  import('@/views/system/fwzc/wyzc/zxgs/details.vue')
              },
              {
                path: '/cywjxz', //常用文件下载

                component: () =>
                  import('@/views/system/fwzc/wyzc/cywjxz/cywjxz.vue')
              },
              {
                path: '/cywjxz/:id', //常用文件下载--详情
                component: () =>
                  import('@/views/system/fwzc/wyzc/cywjxz/details.vue')
              }
            ]
          },
          {
            path: '/wyks', //我要考试
            name: 'wyks',
            component: () => import('@/views/system/fwzc/wyks/index.vue'),
            hidden: true,
            redirect: '/ksdg',
            children: [
              {
                path: '/ksdg', //考试大纲
                component: () =>
                  import('@/views/system/fwzc/wyks/ksdg/ksdg.vue')
              },
              {
                path: '/ksdg/:id', //考试大纲--详情
                component: () =>
                  import('@/views/system/fwzc/wyks/ksdg/details.vue')
              },
              {
                path: '/kstz', //考试通知
                component: () =>
                  import('@/views/system/fwzc/wyks/kstz/kstz.vue')
              },
              {
                path: '/kstz/:id', //考试通知--详情
                component: () =>
                  import('@/views/system/fwzc/wyks/kstz/details.vue')
              },
              {
                path: '/kscjcx', //考试成绩查询
                component: () =>
                  import('@/views/system/fwzc/wyks/kscjcx/kscjcx.vue')
              },
              {
                path: '/kscjcx/:id', //考试成绩查询--详情
                component: () =>
                  import('@/views/system/fwzc/wyks/kscjcx/details.vue')
              }
            ]
          },
          {
            path: '/wypx', //我要培训
            name: 'wypx',
            component: () => import('@/views/system/fwzc/wypx/index.vue'),
            hidden: true,
            redirect: '/pxtz',
            children: [
              {
                path: '/pxtz', //培训通知
                component: () =>
                  import('@/views/system/fwzc/wypx/pxtz/pxtz.vue')
              },
              {
                path: '/pxtz/:id', //培训通知--详情
                component: () =>
                  import('@/views/system/fwzc/wypx/pxtz/details.vue')
              },
              {
                path: '/kcgj', //课程共建
                component: () =>
                  import('@/views/system/fwzc/wypx/kcgj/kcgj.vue')
              },
              {
                path: '/kcgj/:id', //课程共建--详情
                component: () =>
                  import('@/views/system/fwzc/wypx/kcgj/details.vue')
              },
              {
                path: '/cywjxz_wypx', //常用文件下载
                component: () =>
                  import('@/views/system/fwzc/wypx/cywjxz_wypx/cywjxz_wypx.vue')
              },
              {
                path: '/cywjxz_wypx/:id', //常用文件下载--详情
                component: () =>
                  import('@/views/system/fwzc/wypx/cywjxz_wypx/details.vue')
              },
              {
                path: '/pxpt', //国家质量基础设施培训服务平台
                component: () =>
                  import('@/views/system/fwzc/wypx/pxpt/pxpt.vue')
              },
              {
                path: '/pxpt/:id', //国家质量基础设施培训服务平台--详情
                component: () =>
                  import('@/views/system/fwzc/wypx/pxpt/details.vue')
              }
            ]
          },
          {
            path: '/wycx', //我要查询
            name: 'wycx',
            component: () => import('@/views/system/fwzc/wycx/index.vue'),
            hidden: true,
            redirect: '/ggxx1',
            children: [
              {
                path: '/ggxx1', //公告信息
                component: () =>
                  import('@/views/system/fwzc/wycx/ggxx1/ggxx1.vue')
              },
              {
                path: '/ggxx1/:id', //公告信息--详情
                component: () =>
                  import('@/views/system/fwzc/wycx/ggxx1/details.vue')
              },
              {
                path: '/kscjcx1', //考试成绩查询
                component: () =>
                  import('@/views/system/fwzc/wycx/kscjcx1/kscjcx1.vue')
              },
              {
                path: '/kscjcx1/:id', //考试成绩查询--详情
                component: () =>
                  import('@/views/system/fwzc/wycx/kscjcx1/details.vue')
              }
            ]
          },
          {
            path: '/wysbxm', //我要申报项目
            component: () => import('@/views/system/fwzc/wysbxm/wysbxm.vue')
          },
          {
            path: '/wysbxm/:id', //我要申报项目--详情
            component: () => import('@/views/system/fwzc/wysbxm/details.vue')
          },
          {
            path: '/wyzhzyjg', //我要申报项目
            component: () => import('@/views/system/fwzc/wyzhzyjg/wyzhzyjg.vue')
          },
          {
            path: '/wyzhzyjg/:id', //我要申报项目--详情
            component: () => import('@/views/system/fwzc/wyzhzyjg/details.vue')
          },
          {
            path: '/wyzszh', //我要证书转换
            component: () => import('@/views/system/fwzc/wyzszh/wyzszh.vue')
          },
          {
            path: '/wyzszh/:id', //我要证书转换--详情
            component: () => import('@/views/system/fwzc/wyzszh/details.vue')
          },
          {
            path: '/rysts', //人员申投诉
            name: 'rysts',
            component: () => import('@/views/system/fwzc/rysts/index.vue'),
            hidden: true,
            redirect: '/rzryss',
            children: [
              {
                path: '/rzryss', //认证人员申诉
                component: () =>
                  import('@/views/system/fwzc/rysts/RZRYSS/RZRYSS.vue')
              },
              {
                path: '/rzryss/:id', //认证人员申诉--详情
                component: () =>
                  import('@/views/system/fwzc/rysts/RZRYSS/details.vue')
              },
              {
                path: '/rzryts', //认证人员违规投诉
                component: () =>
                  import('@/views/system/fwzc/rysts/rzryts/rzryts.vue')
              },
              {
                path: '/rzryts/:id', //认证人员违规投诉--详情
                component: () =>
                  import('@/views/system/fwzc/rysts/rzryts/details.vue')
              },
              {
                path: '/cywjxz_ryts', //认证人员违规投诉
                component: () =>
                  import('@/views/system/fwzc/rysts/cywjxz_ryts/cywjxz_ryts.vue')
              },
              {
                path: '/cywjxz_ryts/:id', //认证人员违规投诉--详情
                component: () =>
                  import('@/views/system/fwzc/rysts/cywjxz_ryts/details.vue')
              }
            ]
          },
          {
            path: '/hyfw', //会员服务
            name: 'hyfw',
            component: () => import('@/views/system/fwzc/hyfw/index.vue'),
            hidden: true,
            redirect: '/hyml1',
            children: [
              {
                path: '/hyml1', //会员名录
                component: () =>
                  import('@/views/system/fwzc/hyfw/hyml1/hyml1.vue')
              },
              {
                path: '/hyml1/:id', //会员名录--详情
                component: () =>
                  import('@/views/system/fwzc/hyfw/hyml1/details.vue')
              },
              {
                path: '/hyglzd', //会员管理制度
                component: () =>
                  import('@/views/system/fwzc/hyfw/hyglzd/hyglzd.vue')
              },
              {
                path: '/hyglzd/:id', //会员管理制度--详情
                component: () =>
                  import('@/views/system/fwzc/hyfw/hyglzd/details.vue')
              },
              {
                path: '/hyfwsc', //会员服务手册
                component: () =>
                  import('@/views/system/fwzc/hyfw/hyfwsc/hyfwsc.vue')
              },
              {
                path: '/hyfwsc/:id', //会员服务手册--详情
                component: () =>
                  import('@/views/system/fwzc/hyfw/hyfwsc/details.vue')
              },
              {
                path: '/sfxwgs', //收费行为公示
                component: () =>
                  import('@/views/system/fwzc/hyfw/sfxwgs/sfxwgs.vue')
              },
              {
                path: '/sfxwgs/:id', //收费行为公示--详情
                component: () =>
                  import('@/views/system/fwzc/hyfw/sfxwgs/details.vue')
              },
              {
                path: '/fzjgzt', //分支机构动态
                component: () =>
                  import('@/views/system/fwzc/hyfw/fzjgzt/fzjgzt.vue')
              },
              {
                path: '/fzjgzt/:id', //分支机构动态--详情
                component: () =>
                  import('@/views/system/fwzc/hyfw/fzjgzt/details.vue')
              },

              // ----------------------从这里开始改
              {
                path: '/hydt', //会员动态
                component: () =>
                  import('@/views/system/fwzc/hyfw/hydt/hydt.vue')
              },
              {
                path: '/hydt/:id', //会员动态--详情
                component: () =>
                  import('@/views/system/fwzc/hyfw/hydt/details.vue')
              },
              {
                path: '/rcsc', //人才市场
                component: () =>
                  import('@/views/system/fwzc/hyfw/rcsc/rcsc.vue')
              },
              {
                path: '/rcsc/:id', //人才市场--详情
                component: () =>
                  import('@/views/system/fwzc/hyfw/rcsc/details.vue')
              },
              {
                path: '/pphd', //品牌活动
                component: () =>
                  import('@/views/system/fwzc/hyfw/pphd/pphd.vue')
              },
              {
                path: '/pphd/:id', //品牌活动--详情
                component: () =>
                  import('@/views/system/fwzc/hyfw/pphd/details.vue')
              },
              {
                path: '/lshzq', //理事会、常务理事会专区
                component: () =>
                  import('@/views/system/fwzc/hyfw/lshzq/lshzq.vue')
              },
              {
                path: '/lshzq/:id', //理事会、常务理事会专区--详情
                component: () =>
                  import('@/views/system/fwzc/hyfw/lshzq/details.vue')
              },
              {
                path: '/wjxz', //理事会、常务理事会专区
                component: () =>
                  import('@/views/system/fwzc/hyfw/wjxz/wjxz.vue')
              },
              {
                path: '/wjxz/:id', //理事会、常务理事会专区--详情
                component: () =>
                  import('@/views/system/fwzc/hyfw/wjxz/details.vue')
              },
              {
                path: '/zywj', //重要文件
                component: () =>
                  import('@/views/system/fwzc/hyfw/zywj/zywj.vue')
              },
              {
                path: '/zywj/:id', //重要文件--详情
                component: () =>
                  import('@/views/system/fwzc/hyfw/zywj/details.vue')
              },
              {
                path: '/wjytz', //文件与通知
                component: () =>
                  import('@/views/system/fwzc/hyfw/wjytz/wjytz.vue')
              },
              {
                path: '/wjytz/:id', //文件与通知--详情
                component: () =>
                  import('@/views/system/fwzc/hyfw/wjytz/details.vue')
              },
              {
                path: '/lssc', //临时文件上传
                component: () =>
                  import('@/views/system/fwzc/hyfw/lssc/lssc.vue')
              },
              {
                path: '/lssc/:id', //临时文件上传--详情
                component: () =>
                  import('@/views/system/fwzc/hyfw/lssc/details.vue')
              }
            ]
          }
        ]
      },
      //党建专栏
      {
        path: '/djzl',
        name: 'djzl',
        component: () => import('@/views/system/djzl/index'),
        hidden: true,
        redirect: '/djzl',
        children: [
          {
            path: '/djzl', //党建专栏
            component: () => import('@/views/system/djzl/djzl.vue')
          },
          {
            path: '/zyjs', //中央精神
            component: () => import('@/views/system/djzl/zyjs/zyjs.vue')
          },
          {
            path: '/zyjs/:id', //中央精神--详情
            component: () => import('@/views/system/djzl/zyjs/details.vue')
          },
          {
            path: '/xhdjdt', //协会党建动态
            component: () => import('@/views/system/djzl/xhdjdt/xhdjdt.vue')
          },
          {
            path: '/xhdjdt/:id', //行业新闻--详情
            component: () => import('@/views/system/djzl/xhdjdt/details.vue')
          },
          {
            path: '/ssjd', //会员风采
            component: () => import('@/views/system/djzl/ssjd/ssjd.vue')
          },
          {
            path: '/ssjd/:id', //会员风采--详情
            component: () => import('@/views/system/djzl/ssjd/details.vue')
          }
        ]
      },
      //主题教育
      {
        path: '/ztjy',
        name: 'ztjy',
        component: () => import('@/views/system/ztjy/index'),
        hidden: true,
        redirect: '/ztjy',
        children: [
          {
            path: '/ztjy', //主题教育
            component: () => import('@/views/system/ztjy/ztjy.vue')
          },
          {
            path: '/zyjs_zt', //中央精神
            component: () => import('@/views/system/ztjy/zyjs/zyjs.vue')
          },
          {
            path: '/zyjs_zt/:id', //中央精神--详情
            component: () => import('@/views/system/ztjy/zyjs/details.vue')
          },
          {
            path: '/xhdt', //协会动态
            component: () => import('@/views/system/ztjy/xhdt/xhdt.vue')
          },
          {
            path: '/xhdt/:id', //协会动态--详情
            component: () => import('@/views/system/ztjy/xhdt/details.vue')
          },
          {
            path: '/qwjd', //权威解读
            component: () => import('@/views/system/ztjy/qwjd/qwjd.vue')
          },
          {
            path: '/qwjd/:id', //权威解读--详情
            component: () => import('@/views/system/ztjy/qwjd/details.vue')
          },
          {
            path: '/xxyd', //学习园地
            component: () => import('@/views/system/ztjy/xxyd/xxyd.vue')
          },
          {
            path: '/xxyd/:id', //学习园地--详情
            component: () => import('@/views/system/ztjy/xxyd/details.vue')
          }
        ]
      },

      {
        path: '/ztjy',
        name: 'ztjy',
        component: () => import('@/views/system/ztjy/index'),
        hidden: true,
        redirect: '/ztjy',
        children: [
          {
            path: '/ztjy', //信息发布
            component: () => import('@/views/system/ztjy/ztjy.vue')
          }
          // {
          //   path: '/zxtz', //最新通知
          //   component: () => import('@/views/system/xxfb/zxtz/zxtz.vue')
          // },
          // {
          //   path: '/zxtz/:id', //最新通知--详情
          //   component: () => import('@/views/system/xxfb/zxtz/details.vue')
          // },
          // {
          //   path: '/ggsm', //公告声明
          //   component: () => import('@/views/system/xxfb/ggsm/ggsm.vue')
          // },
          // {
          //   path: '/ggsm/:id', //公告声明--详情
          //   component: () => import('@/views/system/xxfb/ggsm/details.vue')
          // },
          // {
          //   path: '/shzrbg', //社会责任报告
          //   component: () => import('@/views/system/xxfb/shzrbg/shzrbg.vue')
          // },
          // {
          //   path: '/shzrbg/:id', //社会责任报告--详情
          //   component: () => import('@/views/system/xxfb/shzrbg/details.vue')
          // }
        ]
      },

      //专题专栏
      {
        path: '/ztzl',
        name: 'ztzl',
        component: () => import('@/views/system/ztzl/index'),
        hidden: true,
        redirect: '/ztzl',
        children: [
          {
            path: '/ztzl', //专题专栏
            component: () => import('@/views/system/ztzl/ztzl.vue')
          },
          {
            path: '/zcfg', //政策法规
            component: () => import('@/views/system/ztzl/zcfg/zcfg.vue')
          },
          {
            path: '/zcfg/:id', //政策法规--详情
            component: () => import('@/views/system/ztzl/zcfg/details.vue')
          },
          {
            path: '/gjhz', //国际合作
            name: 'gjhz',
            component: () => import('@/views/system/ztzl/gjhz/index.vue'),
            hidden: true,
            redirect: '/gjjl',
            children: [
              {
                path: '/gjjl', //国际交流
                component: () =>
                  import('@/views/system/ztzl/gjhz/gjjl/gjjl.vue')
              },
              {
                path: '/gjjl/:id', //国际交流--详情
                component: () =>
                  import('@/views/system/ztzl/gjhz/gjjl/details.vue')
              },
              {
                path: '/gjdt', //国际交流
                component: () =>
                  import('@/views/system/ztzl/gjhz/gjdt/gjdt.vue')
              },
              {
                path: '/gjdt/:id', //国际交流--详情
                component: () =>
                  import('@/views/system/ztzl/gjhz/gjdt/details.vue')
              }
            ]
          },
          {
            path: '/rzjgfzbg', //认证机构发展报告
            name: 'rzjgfzbg',
            component: () => import('@/views/system/ztzl/rzjgfzbg/index.vue'),
            hidden: true,
            redirect: '/zk',
            children: [
              {
                path: '/zk', //国际交流
                component: () =>
                  import('@/views/system/ztzl/rzjgfzbg/zk/zk.vue')
              },
              {
                path: '/zk/:id', //国际交流--详情
                component: () =>
                  import('@/views/system/ztzl/rzjgfzbg/zk/details.vue')
              }
            ]
          },

          // 科研标准
          {
            path: '/kybz', //科研标准
            name: 'kybz',
            component: () => import('@/views/system/ztzl/kybz/index.vue'),
            hidden: true,
            redirect: '/gjbzgl',
            children: [
              {
                path: '/gjbzgl', //国家标准管理
                component: () =>
                  import('@/views/system/ztzl/kybz/gjbzgl/gjbzgl.vue')
              },
              {
                path: '/gjbzgl/:id', //国家标准管理--详情
                component: () =>
                  import('@/views/system/ztzl/kybz/gjbzgl/details.vue')
              },
              {
                path: '/hybzgl', //行业标准管理
                component: () =>
                  import('@/views/system/ztzl/kybz/hybzgl/hybzgl.vue')
              },
              {
                path: '/hybzgl/:id', //行业标准管理--详情
                component: () =>
                  import('@/views/system/ztzl/kybz/hybzgl/details.vue')
              },
              {
                path: '/ttbzgl', //团体标准管理
                component: () =>
                  import('@/views/system/ztzl/kybz/ttbzgl/ttbzgl.vue')
              },
              {
                path: '/ttbzgl/:id', //团体标准管理--详情
                component: () =>
                  import('@/views/system/ztzl/kybz/ttbzgl/details.vue')
              },
              {
                path: '/kyxm', //科研项目
                component: () =>
                  import('@/views/system/ztzl/kybz/kyxm/kyxm.vue')
              },
              {
                path: '/kyxm/:id', //科研项目--详情
                component: () =>
                  import('@/views/system/ztzl/kybz/kyxm/details.vue')
              },
              {
                path: '/kjjps', //科技奖评审
                component: () =>
                  import('@/views/system/ztzl/kybz/kjjps/kjjps.vue')
              },
              {
                path: '/kjjps/:id', //科技奖评审--详情
                component: () =>
                  import('@/views/system/ztzl/kybz/kjjps/details.vue')
              },
              {
                path: '/kjcgpg', //科技成果评估
                component: () =>
                  import('@/views/system/ztzl/kybz/kjcgpg/kjcgpg.vue')
              },
              {
                path: '/kjcgpg/:id', //科技成果评估--详情
                component: () =>
                  import('@/views/system/ztzl/kybz/kjcgpg/details.vue')
              },
              {
                path: '/zjgw', //专家顾问
                component: () =>
                  import('@/views/system/ztzl/kybz/zjgw/zjgw.vue')
              },
              {
                path: '/zjgw/:id', //专家顾问--详情
                component: () =>
                  import('@/views/system/ztzl/kybz/zjgw/details.vue')
              },
              {
                path: '/zgzljtj', //中国专利奖推荐
                component: () =>
                  import('@/views/system/ztzl/kybz/zgzljtj/zgzljtj.vue')
              },
              {
                path: '/zgzljtj/:id', //中国专利奖推荐--详情
                component: () =>
                  import('@/views/system/ztzl/kybz/zgzljtj/details.vue')
              }
            ]
          },
          {
            path: '/rzjstsz', //认证技术提升周
            name: 'rzjstsz',
            component: () => import('@/views/system/ztzl/rzjstsz/index.vue'),
            hidden: true,
            redirect: '/lhal',
            children: [
              {
                path: '/lhal', //良好案例
                component: () =>
                  import('@/views/system/ztzl/rzjstsz/lhal/lhal.vue')
              },
              {
                path: '/lhal/:id', //良好案例--详情
                component: () =>
                  import('@/views/system/ztzl/rzjstsz/lhal/details.vue')
              }
            ]
          },
          {
            path: '/ltzh', //论坛展会
            component: () => import('@/views/system/ztzl/ltzh/ltzh.vue')
          },
          {
            path: '/ltzh/:id', //论坛展会--详情
            component: () => import('@/views/system/ztzl/ltzh/details.vue')
          },
          // {
          //   path: '/rynlpj', //
          //   component: () => import('@/views/system/ztzl/rynlpj/rynlpj.vue')
          // },
          {
            path: '/rynlpj/:id', //
            component: () => import('@/views/system/ztzl/rynlpj/details.vue')
          },
          {
            path: '/rynlpj', //人员能力评价
            name: 'rynlpj',
            component: () => import('@/views/system/ztzl/rynlpj/rynlpj.vue'),
            hidden: true,
            redirect: '/nsy',
            children: [
              {
                path: '/nsy', //rcfzjh /rcfzjh
                name: 'nsy',
                component: () =>
                  import('@/views/system/ztzl/rynlpj/nsy/pjfa/pjfa.vue'),
                hidden: true,
                redirect: '/pjfa',
                children: [
                  {
                    path: '/pjfa', //评价方案
                    component: () =>
                      import('@/views/system/ztzl/rynlpj/nsy/pjfa/pjfa.vue')
                  },
                  {
                    path: '/pjfa/:id', //评价方案--详情
                    component: () =>
                      import('@/views/system/ztzl/rynlpj/nsy/pjfa/details.vue')
                  },
                  {
                    path: '/jyjcry', //检验检测人员
                    component: () =>
                      import('@/views/system/ztzl/rynlpj/nsy/jyjcry/jyjcry.vue')
                  },
                  {
                    path: '/jyjcry/:id', //检验检测人员--详情
                    component: () =>
                      import('@/views/system/ztzl/rynlpj/nsy/jyjcry/details.vue')
                  }
                ]
              },
              {
                path: '/zxs', //咨询师
                component: () =>
                  import('@/views/system/ztzl/rynlpj/zxs/zxs.vue')
              },
              {
                path: '/zxs/:id', //咨询师--详情
                component: () =>
                  import('@/views/system/ztzl/rynlpj/zxs/details.vue')
              },
              {
                path: '/wsqthcy', //
                component: () =>
                  import('@/views/system/ztzl/rynlpj/wsqthcy/wsqthcy.vue')
              },
              {
                path: '/wsqthcy/:id', //
                component: () =>
                  import('@/views/system/ztzl/rynlpj/wsqthcy/details.vue')
              },
              {
                path: '/spaqs',
                component: () =>
                  import('@/views/system/ztzl/rynlpj/spaqs/spaqs.vue')
              },
              {
                path: '/spaqs/:id',
                component: () =>
                  import('@/views/system/ztzl/rynlpj/spaqs/details.vue')
              }
            ]
          }
        ]
      },

      //奋进20载
      {
        path: '/fj20z',
        name: 'fj20z',
        component: () => import('@/views/system/fj20z/index'),
        hidden: true,
        redirect: '/fj20z',
        children: [
          {
            path: '/fj20z', //奋进20载
            component: () => import('@/views/system/fj20z/fj20z.vue')
          },
          {
            path: '/hyhc', //行业贺词
            component: () => import('@/views/system/fj20z/hyhc/hyhc.vue')
          },
          {
            path: '/hyhc/:id', //行业贺词--详情
            component: () => import('@/views/system/fj20z/hyhc/details.vue')
          },
          {
            path: '/hyxs', //会员心声
            component: () => import('@/views/system/fj20z/hyxs/hyxs.vue')
          },
          {
            path: '/hyxs/:id', //会员心声--详情
            component: () => import('@/views/system/fj20z/hyxs/details.vue')
          },
          {
            path: '/zwzs', //正文展示
            component: () => import('@/views/system/fj20z/zwzs/zwzs.vue')
          },
          {
            path: '/zwzs/:id', //正文展示--详情
            component: () => import('@/views/system/fj20z/zwzs/details.vue')
          }
          // ,
          // {
          //   path: '/xxyd_fj', //学习园地
          //   component: () => import('@/views/system/fj20z/xxyd/xxyd.vue')
          // },
          // {
          //   path: '/xxyd_fj/:id', //学习园地--详情
          //   component: () => import('@/views/system/fj20z/xxyd/details.vue')
          // }
        ]
      },

      //收费公示
      {
        path: '/sfgs',
        name: 'sfgs',
        component: () => import('@/views/system/sfgs/index'),
        hidden: true,
        redirect: '/sfgs',
        children: [
          {
            path: '/sfgs', //收费公示
            component: () => import('@/views/system/sfgs/sfgs.vue')
          },
          {
            path: '/sfgs/:id', //最新通知--详情
            component: () => import('@/views/system/sfgs/details.vue')
          }
        ]
      },

      //联系我们
      {
        path: '/lxwm',
        name: 'lxwm',
        component: () => import('@/views/system/lxwm/index'),
        hidden: true,
        redirect: '/lxwm',
        children: [
          {
            path: '/zxns',
            name: 'zxns',
            component: () => import('@/views/system/lxwm/zxns/index.vue'),
            hidden: true,
            redirect: '/zpqs',
            children: [
              {
                path: '/zpqs', //联系我们 招聘启示
                component: () =>
                  import('@/views/system/lxwm/zxns/zpqs/zpqs.vue')
              },
              {
                path: '/zpqs/:id', // 招聘启示--详情
                component: () =>
                  import('@/views/system/lxwm/zxns/zpqs/details.vue')
              },
              {
                path: '/zwsqbxz', //联系我们 招聘启示
                component: () =>
                  import('@/views/system/lxwm/zxns/zwsqbxz/zwsqbxz.vue')
              },
              {
                path: '/zwsqbxz/:id', // 招聘启示--详情
                component: () =>
                  import('@/views/system/lxwm/zxns/zwsqbxz/details.vue')
              }
            ]
          },
          {
            path: '/cjwt', //常见问题
            component: () => import('@/views/system/lxwm/cjwt/cjwt.vue')
          },
          {
            path: '/cjwt/:id', // 常见问题
            component: () => import('@/views/system/lxwm/cjwt/details.vue')
          },
          {
            path: '/dcwj', //调查问卷
            component: () => import('@/views/system/lxwm/dcwj/dcwj.vue')
          },
          {
            path: '/dcwj/:id', // 调查问卷
            component: () => import('@/views/system/lxwm/dcwj/details.vue')
          },
          {
            path: '/fwdh', //服务电话
            component: () => import('@/views/system/lxwm/fwdh/fwdh.vue')
          },
          {
            path: '/fwdh/:id', // 服务电话
            component: () => import('@/views/system/lxwm/fwdh/details.vue')
          }
        ]
      },
      //杂志社
      {
        path: '/zzs',
        name: 'zzs',
        component: () => import('@/views/system/zzs/index'),
        hidden: true,
        redirect: '/zzjj',
        children: [
          {
            path: '/zzjj', //杂志简介
            component: () => import('@/views/system/zzs/zzjj.vue')
          },
          {
            path: '/wkjs', //往刊介绍
            component: () => import('@/views/system/zzs/wkjs.vue')
          }
        ]
      },

      //搜索页面
      {
        path: '/search',
        name: 'search',
        component: () => import('@/views/system/search/index'),
        hidden: true,
        redirect: '/search',
        children: [
          {
            path: '/search', //搜索页面
            component: () => import('@/views/system/search/search.vue')
          },
          {
            path: '/search/:id', //搜索页面--详情
            component: () => import('@/views/system/search/details.vue')
          }
        ]
      },
      {
        path: '404',
        name: 'error',
        component: () => import('@/views/404'),
        hidden: true
      }
    ]
  },
  {
    path: '/redirect',
    component: Layout,
    name: 'redirect',
    hidden: true,
    children: [
      {
        path: '/redirect/:path*',
        component: () => import('@/views/redirect/index')
      }
    ]
  }
]

const createRouter = () =>
  new Router({
    // mode: 'dw', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: StaticRouterMap
  })

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
